class Geoloc {
    static getPosition() {
        return new Promise((resolve, reject) => {

            if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.MobileDevIOSAppMessageHandler) {

                let _mobileDevIOSAppMessageHandler = window.webkit.messageHandlers.MobileDevIOSAppMessageHandler;
                var _mobileDevIOSAppMessageHandlerResolve;
                var _mobileDevIOSAppMessageHandlerReject;

                var pos = new Promise(function(resolve, reject) {
                    _mobileDevIOSAppMessageHandler.postMessage('requestGeolocation');
                    _mobileDevIOSAppMessageHandlerResolve = resolve;
                    _mobileDevIOSAppMessageHandlerReject = reject;
                });


                window._retrieveGeolocation = function(state,lat,lng){
                    if(state == 0){
                        reject('Geoloc indisponible sur cet appareil iOS, verifier les autorisations');
                        if(_mobileDevIOSAppMessageHandlerReject){
                            _mobileDevIOSAppMessageHandlerReject();
                        }
                    }
                    else{
                        if(_mobileDevIOSAppMessageHandlerResolve){

                            let coords = {
                                'coords' : {
                                    'latitude' : null,
                                    'longitude' : null
                                }
                            }

                            coords.coords.latitude = lat;
                            coords.coords.longitude = lng;

                            _mobileDevIOSAppMessageHandlerResolve(coords);
                        }
                    }
                }

                pos.then(function(coords){
                    //console.log('Geoloc (iOS) : ', coords);

                    resolve(coords);
                })
                /*
                if(pos.coords.latitude === null){
                    reject('Geoloc indisponible sur cet appareil iOS');
                }else{
                    resolve(pos);
                }*/


            }else{
                if (!"geolocation" in navigator) {
                    reject('Geoloc indisponible sur cet appareil')
                }

                navigator.geolocation._getCurrentPosition = navigator.geolocation.getCurrentPosition;

                navigator.geolocation.getCurrentPosition(
                    (pos) => {
                        resolve(pos)

                    },
                    (err) => {
                        reject(err)
                    },

                    // OPTIONS
                    {
                        enableHighAccuracy: true,
                        timeout: 10000,
                        maximumAge: 0
                    }
                );
            }

        })
    }
}

export default Geoloc



// WEBPACK FOOTER //
// ./src/js/models/Geoloc.js